// extracted by mini-css-extract-plugin
export default {"stack":"Footer_stack__lx-D3","footerText":"Footer_footerText__pxkiP","icons":"Footer_icons__DzXFN"};